import { format, isValid, parse } from "date-fns";

export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd";

export const generateMonthNames = () => {
  const months: string[] = [];

  for (let i = 0; i < 12; i++) {
    const currentMonth = new Date(new Date().getFullYear(), i, 1);
    const monthName = format(currentMonth, 'MMMM');
    months.push(monthName);
  }

  return months;
};

export const isValidDate = (dateString: string, dFormat: string) => {
  try {
      if (dateString.length !== dFormat.length) {
          return false;
      }
      const parsedDate = parse(dateString, dFormat, new Date());
      return isValid(parsedDate);
  } catch (error) {
      return false;
  }
};

export const parseDateWithFormats = (dateString: string, formats: string | string[]): Date | null => {
  const formatArray = Array.isArray(formats) ? formats : [formats];

  for (const format of formatArray) {
    try {
      const parsedDate = parse(dateString, format, new Date());
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    } catch (error) {
      // Parsing failed with this format, try the next one
    }
  }

  // Unable to parse with any format
  return null;
};
